module.exports = __webpack_public_path__ + "img/good-1.85a55619.png";